// 校验手机号码正则匹配
export function checkTel (tel) {
  var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
  if (!myreg.test(tel)) {
    return false
  } else {
    return true
  }
}

// 简单的加密
export function setEscape (code) {
  let c = String.fromCharCode(code.charCodeAt(0) + code.length)
  for (let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
  }
  return escape(c)
}

// 简单的解密
export function unsetEscape (code) {
  code = unescape(code)
  let c = String.fromCharCode(code.charCodeAt(0) - code.length)
  for (let i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
  }
  return c
}

// 设置cookie: cookie名，cookie值，天数
export function setCookie (name, value, iDay) {
  var oDate = new Date()
  oDate.setDate(oDate.getDate() + iDay)
  document.cookie = name + '=' + value + '; expires = ' + oDate
}

// 获取cookie
export function getCookie (name) {
  var arr = document.cookie.split('; ')// 将cookie切割成数组
  for (var i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split('=') // 数组元素以等号切割
    if (arr2[0] === name) {
      return arr2[1] // 获取cookie名对应的cookie值
    }
  }
  return '' // 如果没有获取到值，返回空字符串
}

// 删除cookie
export function removeCookie (name) {
  setCookie(name, 1, -1)
}

// 按照规则打乱字符串，然后解密之后再反转回来
export function disruptString (str) {
  let newstr
  if (str) {
    newstr = str.split('').reverse().join('') + '150'
  }
  return newstr
}
// 按照规则打乱字符串，然后解密之后再反转回来
export function unDisruptString (str) {
  let newstr
  if (str) {
    newstr = str.split('').reverse().join('').substr(3)
  }
  return newstr
}

// 截取字符串 ➲

export function resolveArryisCopyBuy (value) {
  let arr = []
  if (value) {
    arr = value.split('➲')
  }
  arr.splice(-1)
  console.log('arr', arr)
  return value ? arr : ''
}

// 请求状态码
export const statusCode = {
  REQ_OK: 0,
  REQ_ERR: 1,
  REQ_TWO: 2,
  REQ_THREE: 3,
  REQ_FIVE: 5,
  REQ_FOUR: 4,
  REQ_SEVEN: 7,
  REQ_TWN: 10, // 手机号码未注册
  TIME_OUT: 999
}



// WEBPACK FOOTER //
// ./src/common/js/utils.js